<template>
  <b-modal
    :visible="show"
    @hide="onClose"
    title="Editar Proposta"
    hide-footer
  >
    <div>
      <p><strong>Nº Pedido:</strong> {{ pedido && pedido.cd_renegociacao_divida }}</p>
      <b-form-group label="Valor Proposta">
        <b-form-input v-model="localPedido.vl_proposta" type="text" v-money="money" />
      </b-form-group>
      <b-form-group label="Data de Vencimento">
        <b-form-input v-model="localPedido.dt_vencimento_proposta" type="date" :value="formatDate(localPedido.dt_vencimento_proposta)" @input="updateVencimento" />
      </b-form-group>
      <div class="d-flex justify-content-end">
        <b-button variant="secondary" @click="onClose">Fechar</b-button>
        <b-button variant="primary" class="ml-2" @click="onSave">Salvar</b-button>
      </div>
    </div>
  </b-modal>
</template>

<script>
import API from '@/services/api';

export default {
  name: "RenegociacaoEditarModal",
  props: {
    show: { type: Boolean, default: false },
    pedido: { type: Object, default: () => ({}) }
  },
  data() {
    return {
      localPedido: { ...this.pedido },
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        precision: 2,
        masked: false
      }
    };
  },
  watch: {
    pedido: {
      handler(nv) {
        // Converte para yyyy-mm-dd se vier como dd/mm/yyyy
        let venc = nv.dt_vencimento_proposta;
        if (venc && venc.includes('/')) {
          const parts = venc.split('/');
          nv.dt_vencimento_proposta = `${parts[2]}-${parts[1].padStart(2, '0')}-${parts[0].padStart(2, '0')}`;
        }
        this.localPedido = { ...nv };
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    formatDate(date) {
      if (!date) return '';
      // Se já estiver no formato yyyy-mm-dd, retorna direto
      if (/^\d{4}-\d{2}-\d{2}$/.test(date)) return date;
      // Se vier como dd/mm/yyyy, converte
      const parts = date.split('/');
      if (parts.length === 3) {
        return `${parts[2]}-${parts[1].padStart(2, '0')}-${parts[0].padStart(2, '0')}`;
      }
      return date;
    },
    updateVencimento(e) {
      this.localPedido.dt_vencimento_proposta = e.target.value;
    },
    onClose() {
      this.$emit("close");
    },
    async onSave() {
      try {
        const token = localStorage.getItem('jwtToken');
        const payload = { ...this.localPedido, token };
        const res = await API.post('/renegociacao_divida_protestada/editar-pedido', payload);
        if (res.data && res.data.success) {
          this.$bvToast.toast(res.data.message || 'Pedido atualizado com sucesso.', { variant: 'success', solid: true });
          this.$emit("save", { ...this.localPedido });
          this.$emit("close");
        } else {
          this.$bvToast.toast(res.data.message || 'Nenhuma alteração detectada.', { variant: 'warning', solid: true });
        }
      } catch (e) {
        this.$bvToast.toast('Erro inesperado ao salvar alterações.', { variant: 'danger', solid: true });
      }
    }
  }
};
</script>
